export const config = {
    // url: 'https://jt-project-99346a31be1a.herokuapp.com',
    // url: 'http://floworg-crm.mediatech4u.com'
    // url: 'http://localhost:8080'
    url: 'https://crm-v1-b-fnrmwlgx.on-forge.com'
}